/**
 * Created by fers on 01.07.16.
 */
 /* global $ */

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import '../screen-settings/ScreenSettings.scss';
import BoxDisplayer, {getHandler} from './BoxDisplayer.react';
import Immutable from 'immutable';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import EmptyContent from '../box/system/EmptyContent.react';
import EmptyList from '../box/system/EmptyList.react';
import BoxDecorator from './BoxDecorator.react';
import {getViewFragment, getDataSourceFragment} from './ScreenFragments.react';
import CachingRequired from '../box/system/CachingRequired.react';
import InvalidQuery from '../box/system/InvalidQuery.react';
import {safeJSONparse} from "../../../common/util/safeJSONparse";

export class ScreenDisplayerListener {

	// eslint-disable-next-line max-params
    onTabTitle(content, subtree, keypath, child, idx) {
        return content;
    }

	// eslint-disable-next-line max-params
    afterTabTitles(content, subtree, keypath) {
        return content;
    }

	// eslint-disable-next-line max-params
    onColumn(content, subtree, keypath, child, idx) {
        return content;
    }

    afterColumns(content, subtree, keypath) {
        return content;
    }

	// eslint-disable-next-line max-params
    onBox(content, subtree, keypath, child, idx) {
        return content;
    }

    afterBoxes(content, subtree, keypath) {
        return content;
    }

	// eslint-disable-next-line max-params
    onLayout(content, subtree, keypath, child, idx) {
        return content;
    }
}

export default class ScreenDisplayer extends React.Component {

    static propTypes = {
		activeTab: PropTypes.string,
        content: PropTypes.any.isRequired,
        isPreview: PropTypes.bool,
        listener: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        viewsWithData: PropTypes.array.isRequired,
    };

    static defaultProps = {
        isPreview: false,
    };

    constructor(props) {
        super(props);
        this.componentWillReceiveProps(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

		this.state = {
			dragOver: false,
			closeTabHover: false
		};
    }

    componentWillReceiveProps(props) {
        let content = props.content;
        if (typeof props.content === "string") {
            content = safeJSONparse(content);
        }

        this.content = Immutable.fromJS(content);

        if (!this.content || this.content.size === 0) {
            this.content = Immutable.fromJS({
                'layout': 'list',
                'views': [],
            });
        }
    }

    createElement(viewWithData, idx) {
        return (
            <BoxDisplayer isPreview={this.props.isPreview} key={idx} relay={this.props.relay} viewWithData={viewWithData} />
        );
    }

    renderColumns(subtree, keypath) {
        if (!subtree.has('children')) {
            return;
        }

        let weights = subtree.get('children').map((child) => {
            let weight = 1;
            if (child.has('weight')) {
                weight = Number.valueOf(child.get('weight'));
            }

            if (!weight || weight < 1) {
                weight = 1;
            }

            return weight;
        });


        let totalWeight = weights.reduce((total, weight) => {
            return total + weight;
        }, 0);

		return (
			<div className="panelColumnsWrap">
				{this.props.listener.afterColumns(subtree.get('children').map((child, idx) => {
					let width = weights.get(idx) / totalWeight * 100.0;
					return (
						<div className="panelColumnItem" key={idx} style={{maxWidth: ("" + width + "%")}}>
							{this.props.listener.onColumn(this.renderChoose(subtree, child, [...keypath, 'children', idx], idx), subtree, keypath, child, idx)}
						</div>
					);
				}), subtree, keypath)}
			</div>
		);
    }

	switchTab(tabId) {
        if (typeof window === 'object' && '$' in window) {
            $('a[href="' + tabId + '"]').tab('show');
        }
	}

	onTabCloseEnter(idx, proxy) {
		let li = proxy.target.closest('li');

		li.classList.add('closeHover');

		if (li.classList.contains('active')) {
			li.closest('.tabWrapper').classList.add('closeHover');
		}
	}

	onTabCloseOut(idx, proxy) {
		let li = proxy.target.closest('li');

		li.classList.remove('closeHover');
		li.closest('.tabWrapper').classList.remove('closeHover');
	}

	getTabId(keyPathStr, idx) {
		return "#tab-" + keyPathStr + "-" + idx;
	}

    renderTabs(subtree, keypath) {
        if (!subtree.has('children')) {
            return;
        }

        const keyPathStr = keypath.join('-');
		let children = subtree.get('children');

        return (
            <div className="tabWrapper">
				<div className="panelTabsWrapper">
					<ul className="nav nav-tabs panelTabs">
						{this.props.listener.afterTabTitles(children.map((child, idx) => {
							let tabId = this.getTabId(keyPathStr, idx);

							return (
								<li className={(idx === 0 ? "active" : "")} key={idx}>
									<a data-toggle="tab" href={tabId} onDragEnter={() => {this.switchTab(tabId);}}>{this.props.listener.onTabTitle(<span>{child.get('name')}</span>, subtree, keypath, child, idx, {enter: this.onTabCloseEnter.bind(this, idx), out: this.onTabCloseOut.bind(this, idx)})}</a>
								</li>
							);
						}), subtree, keypath)}
					</ul>
				</div>
                <div className="tab-content panelTabsContent">
                    {subtree.get('children').map((child, idx) => {
                        return (
                            <div className={"tab-pane "  + (idx === 0 ? "active" : "")} id={"tab-" + keyPathStr + "-" + idx} key={idx}>
                                {this.renderChoose(subtree, child, [...keypath, 'children', idx], idx)}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

	// eslint-disable-next-line max-params
    renderChoose(parent, subtree, keypath, idx) {
        let layout = subtree.get('layout') || 'list';
        let result;

		switch (layout) {
			case 'columns':
				result = this.renderColumns(subtree, keypath);
				break;
			case 'tabs':
				result = this.renderTabs(subtree, keypath);
				break;
			case 'list':
				result = this.renderList(subtree, keypath);
				break;
			default:
				result = <span>Unknown {layout}</span>;
		}

        return this.props.listener.onLayout(result, parent, keypath, subtree, idx);
    }

    findView(id) {
        return this.props.viewsWithData.find((viewWithData) => viewWithData['view'] && viewWithData['view']['realId'] === id);
    }

	dragStart = () => {
		this.setState({
			dragOver: true
		});
	}

	dragEnd = (proxy, event) => {
		// exclude possible child elements which invokes dragLeave event
		if (proxy.target.classList.contains('dragAppendActive') || (proxy.target.classList.contains('draggableBox') && proxy.target.classList.contains('notVisible'))) {
			proxy.stopPropagation();
			if (event) {
				event.stopPropagation();
			}
			return;
		}

		this.setState({
			dragOver: false
		});
	}

    renderList(subtree, keypath) {
        let out = [];
		let emptyBox = false;
		let noDataElement = false;

        if (subtree.has('views')) {
            let views = subtree.get('views').map((view, idx) => {
                try {
                    let viewWithData = this.findView(view);

                    if (viewWithData) {
                        if (viewWithData.invalidQuery) {
                            return (<InvalidQuery key={idx} viewWithData={viewWithData} />);
                        }

                        if (viewWithData.cachingRequired) {
                            return (<CachingRequired key={idx} viewWithData={viewWithData} />);
                        }

                        if (!this.props.isPreview && !viewWithData.error) {
                            let handler = getHandler(viewWithData);

                            if (handler && handler.WrappedComponent.isEmpty(viewWithData)) {
                                if (noDataElement) {
                                    return null;
                                }

                                noDataElement = true;
                                return (<BoxDecorator icon="" isPreview={false} key={idx}
                                                      title=""><EmptyContent /></BoxDecorator>);
                            }
                        }

                        noDataElement = false;
                        return (
                            this.props.listener.onBox(this.createElement(viewWithData, idx), subtree, keypath, view, idx)
                        );
                    }

                    console.log("Missing view", view); // eslint-disable-line no-console
                    return null;
                } catch (e) {
                    console.error("Error in view", view, e); // eslint-disable-line no-console
                    return null;
                }
            });

            if (!this.props.isPreview) {
				if (views.size !== 0) {
					views = views.push(<div className="panelColumnsLastSpacer" key="last"></div>);
				}
            }

			if (views.size === 0) {
				emptyBox = true;
			}
			if (emptyBox && !this.props.isPreview) {
				out.push(<BoxDecorator icon="" isPreview={this.props.isPreview} key="1" title=""><EmptyList /></BoxDecorator>, <div className="panelColumnsLastSpacer" key="2"></div>);
			}
			else {
				out = this.props.listener.afterBoxes(views, subtree, keypath);
			}
        } else {
            out.push(<span key="error">Error</span>);
        }

        return <div className={"panelList" + (emptyBox ? ' emptyPanel' : '') + (this.state.dragOver ? ' dragOver' : '')} onDragEnd={this.dragEnd} onDragEnter={this.dragStart} onDragExit={this.dragEnd} onDragLeave={this.dragEnd} onDragOver={this.dragStart}>{out}</div>;
    }

    render() {
		let isEmpty = !this.content.has('children') || 0 === this.content.get('children').size;

		if (this.props.activeTab !== '') {
			let self = this;
			setTimeout(() => {
				self.switchTab(self.props.activeTab);
			}, 10);
		}

        return (
            <div className={"panelColumns " + (this.props.isPreview ? "panelColumnsIsPreview" : "") + (isEmpty ? " emptyPanel" : "")}>
                {this.renderChoose(null, this.content, [], 0)}
            </div>
        );
    }
}

export function getEditDataSourceFragment() {
    return Relay.QL`
        fragment on DataSource {
            ${getDataSourceFragment()}
            args,
            screen_id,
            checkValidity,
            entitySelectionRules {
                id,
                realId,
                entityDef_id,
                channelDef_id,
                channelDefKey,
                sourceDef_id,
                channel_id,
            },
            helperSelectionRules {
                id,
                realId,
                entityDef_id,
                channelDef_id,
                channelDefKey,
                sourceDef_id,
                channel_id,
            },
            boxesToAdd {
                id,
                name,
                realId,
                handler,
                connectedChannel_id,
                backendOptions,
                order,
                filter,
                connectedChannel {
                    id,
                    realId,
                    channelDef {
                        id,
                        icon,
                        name,
                    }
                },
                connectedChannelDef_id,
                connectedChannelDef {
                    id,
                    realId,
                    icon,
                    name,
                },
                entityDef {
                    id,
                    realId,
                    icon,
                    inheritedIcon,
                },
                entityViewDef {
                    id,
                    realId,
                    name,
                    description,
                    handler,
                    backendHandlers,
                    backendOptions,
                    forList,
                    title,
                    template,
					order,
					filter,
                },
                channelAddonChannel_id,
                channelAddon {
                    id,
                    realId,
                    organisation_id,
                    channel_id,
                    name,
                    options,
                    addonDef {
                        id,
                        realId,
                        name,
                        handler,
                        options,
                        channelDef {
                            id,
                            name,
                            realId,
                            icon
                        }
                    }
                }
            }
        }
    `;
}

export function getEditViewFragment() {
    return Relay.QL`
        fragment on View {
            ${getViewFragment()}
            screen_id,
            backendHandlers,
            backendOptions,
            entityViewDef {
                backendHandlers,
                backendOptions,
            }
        }
    `;
}
